module.exports = {"230305001":"街里街道","230305002":"穆棱街道","230305003":"平岗街道","230305004":"碱场街道","230305005":"石磷街道","230305198":"梨树区（镇）直辖地域"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230305.json
// module id = 652
// module chunks = 0